import { Flex, useColorMode } from "@chakra-ui/react";
import FadeTransition from "src/components/FadeTransition";
import environment from "src/utils/environment";
import BatteryStatus from "./BatteryStatus";
import MonitoringTimer from "./MonitoringTimer";
import { Activities } from "src/modules/activity-log/activity";
import {
  LullabyReplayIndicator,
  Muted,
  MotionError,
  LowLightIndicator
} from "src/modules/parent-station/active-feature";

export default function MonitoringStatus({
  activatableFeatures = {},
  openLullabyPlayer,
  lullabyPlayer,
  monitoringStartTime,
  batteryStatus,
  mode,
  error,
  activity,
  canDetectMotion,
  motionDetectorState,
  lowLightDetected,
  lowLightMode,
  isInTileView
}) {
  const { colorMode } = useColorMode();
  const isDarkMode = colorMode === "dark";
  const hasActiveFeature = Object.values(activatableFeatures).some(
    (feature) => feature
  );
  const hasMotionError = !canDetectMotion;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      py="1px"
      maxHeight={["18px", "24px", "28px"]}
    >
      <MonitoringTimer
        monitoringStartTime={monitoringStartTime}
        isDarkMode={
          mode === "video" ||
          error ||
          isDarkMode ||
          activity === Activities.AWAKE ||
          (activity === Activities.MOTION && environment.isBibino)
        }
        mode={mode}
        error={error}
        activity={activity}
      />
      <FadeTransition
        unmountOnExit
        mountOnEnter
        show={hasActiveFeature || hasMotionError || lowLightDetected}
      >
        <Flex
          alignItems="center"
          sx={{
            "& > *": {
              mr: "8px"
            },
            "&:last-child": {
              mr: "0px"
            }
          }}
        >
          {activatableFeatures.playingLullaby && (
            <LullabyReplayIndicator
              openLullabyPlayer={openLullabyPlayer}
              lullabyPlayer={lullabyPlayer}
              mode={mode}
              error={error}
              activity={activity}
              isDarkMode={isDarkMode}
            />
          )}
          {activatableFeatures.muted && (
            <Muted
              mode={mode}
              error={error}
              activity={activity}
              isDarkMode={isDarkMode}
            />
          )}
          {!isInTileView && lowLightDetected && mode === "video" && (
            <LowLightIndicator
              mode={mode}
              error={error}
              activity={activity}
              isDarkMode={isDarkMode}
              lowLightMode={lowLightMode}
            />
          )}
          {hasMotionError && (
            <MotionError
              motionDetectorState={motionDetectorState}
              mode={mode}
              error={error}
              activity={activity}
              isDarkMode={isDarkMode}
              isParentStation
            />
          )}
        </Flex>
      </FadeTransition>
      <BatteryStatus
        ml="16px"
        battery={batteryStatus}
        isDarkMode={
          mode === "video" ||
          error ||
          isDarkMode ||
          activity === Activities.AWAKE ||
          (activity === Activities.MOTION && environment.isBibino)
        }
      />
    </Flex>
  );
}
